import { render } from "./SelectChanelWidget.vue?vue&type=template&id=cadff6cc&scoped=true&ts=true"
import script from "./SelectChanelWidget.vue?vue&type=script&lang=ts"
export * from "./SelectChanelWidget.vue?vue&type=script&lang=ts"

import "./SelectChanelWidget.vue?vue&type=style&index=0&id=cadff6cc&scoped=true&lang=scss"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cadff6cc"]])

export default __exports__